import React from "react";
import Portfolio from "./components/Portfolio"; 

// Import other components like About, Projects, Skills, etc. when you're ready

function App() {
  return (
    <div>
     
      <Portfolio />

      {/* Other sections can be added here later */}
    
      {/* <Projects /> */}
      {/* <Skills /> */}
      {/* <Contact /> */}
    </div>
  );
}

export default App;
